import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/calendar'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'calendar_settings',
          component: Index,
          meta: {
            permissions: ['administrator', 'owner', 'calendar_manage_all'],
            featureFlag: FEATURE_FLAGS.WORKSPACE_CALENDAR,
          },
        },
      ],
    },
  ],
};
